import React, { useState, useEffect } from 'react';

const Alert = ({ key, successMessage, errorMessage }) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [alertClass, setAlertClass] = useState('');

  useEffect(() => {
    if (successMessage || errorMessage) {
      setMessage(successMessage || errorMessage);
      setAlertClass(successMessage ? 'alert-success' : 'alert-danger');
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setMessage('');
      }, 3000);

      // Cleanup the timer if the component unmounts before the timer fires
      return () => clearTimeout(timer);
    }
  }, [key, successMessage, errorMessage]);

  return (
    visible && message && (
      <div className={`alert ${alertClass} mb-3 h7`}>{message}</div>
    )
  );
};

export default Alert;